<template>
  <div class="has-campaignCuration-component">
    <div class="column is-8 is-offset-2">
      <div class="columns">
        <div class="column is-full">
          <p class="is-size-3 has-text-centered has-text-grey-dark dm-sans">
            Você deseja algum serviço complementar?
          </p>
        </div>
      </div>
      <div class="columns" v-for="(extraService, index) in extraServices" :key="index">
        <div class="column is-full">
          <div class="card is-bordered">
            <header class="card-header">
              <p class="card-header-title">
                {{ extraService.name }}
              </p>
              <button class="card-header-icon" aria-label="more options">
                <number-input
                    v-model="extraService.quantity"
                    :min="0"
                    :max="countChips"
                    @change="onChange(extraService)"
                    class="is-primary"
                    center
                    inline
                    controls
                ></number-input>
              </button>
            </header>
            <div class="card-content">
              <div class="content">
                <span class="has-text-grey-secondary has-text-weight-bold">
                  + R$ {{ formatPrice(extraService.price) }} {{ extraService.unit_of_measurement }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import extraServicesApi from '@/apis/extraServices'

export default {

  name: 'extra-services',

  data() {
    return {
      extraServices: []
    }
  },

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  watch: {
    'formData.plan': {
      handler() {
        this.getExtraServices()
      },
      deep: true
    }
  },

  computed: {
    countChips() {
      return this.formData.extraChips.data.quantity ? this.formData.extraChips.data.quantity : 1;
    }
  },

  methods: {
    cleanData() {
      this.extraServices = []
      this.formData.extraServices.data = []
      this.getExtraServices()
    },
    onChange(extraService) {
      const extraServiceIndex = this.formData.extraServices.data.findIndex((es) => es.id === extraService.id)
      if (extraServiceIndex === -1 && !(extraService.quantity === 0)) {
        return this.formData.extraServices.data.push(extraService)
      }

      if (extraService.quantity === 0) {
        return this.formData.extraServices.data.splice(extraServiceIndex, 1)
      }

      this.formData.extraServices.data[extraServiceIndex] = extraService
    },
    formatPrice(value) {
      return (parseFloat(value).toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' }))
          .replace('R$', '').trim();
    },
    async getExtraServices() {
      if (this.formData.plan.data.id) {
        this.extraServices = await extraServicesApi.get({
          plan_id: this.formData.plan.data.id
        })
      }
    }
  },

  mounted() {
    this.getExtraServices()
  }

}

</script>

<style lang="scss">
  .number-input {
    max-width: 8rem !important;
    .number-input__button {
      &::after {
        background-color: #0091f8!important;
      }
      &::before {
        background-color: #0091f8!important;
      }
    }
    .number-input__button--plus {
      cursor: pointer;
    }

    .number-input__button--minus {
      cursor: pointer;
    }
  }
</style>